export enum RafflingArrayVariantEnum {
  ALL = 'all',
  ONE_OF = 'oneOf'
}
